/**
 * URLs omitidas das listagens de requisições no dashboard (erros recentes, sucessos,
 * processos em execução, métricas por endpoint).
 */
export const DASHBOARD_EXCLUDED_URL_PATTERNS = [
  '/auth/refresh',
  '/api/v1/server',
  '/api/v1/auth/login',
  '/api-docs',
  '/api/v1/metrics',
  '/health',
] as const;

export function isDashboardExcludedUrl(url: string): boolean {
  return DASHBOARD_EXCLUDED_URL_PATTERNS.some((pattern) => url.includes(pattern));
}

/** Endpoints exibidos no gráfico/tabela “Endpoints Mais Utilizados” (exclui métricas e documentação Swagger). */
export function includeEndpointInDashboardMetrics(endpoint: string): boolean {
  const path = endpoint.toLowerCase();
  const isInternalMetrics = path.includes('/metrics') || path.startsWith('/metrics');
  const isApiDocs = path.includes('/api-docs');
  return !isInternalMetrics && !isApiDocs;
}
